import React from "react";
import { useLanguage } from "../../components/hooks/LanguageContext"; // <-- импортируем хук

const AboutProductSection = ({ link }) => {
    const { language } = useLanguage(); // используем глобальный язык

    // Тексты на разных языках
    const textContent = {
        ru: {
            title: "Начни свой бизнес вместе с искусственным интеллектом",
            button: "Узнать больше"
        },
        en: {
            title: "Start your business with Artificial Intelligence",
            button: "Learn More"
        }
    };

    const currentText = textContent[language]; // текущий язык

    return (
        <section className="features035 cid-uB0EGy2eUo" id="call-to-action-11-uB0EGy2eUo">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-9 active">
                        <div className="item-wrapper">
                            <div className="card-box">
                                <h4 className="card-text mbr-fonts-style display-7">
                                    {currentText.title}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-3 active">
                        <div className="mbr-section-btn">
                            <a className="btn-success-outline btn display-7" href={`#${link}`}>
                                {currentText.button}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutProductSection;
